import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "./../component/Header";
import Sidebar from "./../component/Sidebar"; // Corrected the component name here

const removeIcon = require("./../assets/img/remove-icon.svg").default;
const viewIcon = require("./../assets/img/eye-icon.svg").default;
const uploadImg = require("./../assets/img/upload-button.svg").default;
const searchIcon = require("./../assets/img/search-icon.svg").default;

const ViewFiles = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [fileData, setFileData] = useState([]);
  const [userData, setUserData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedFiles, setSelectedFiles] = useState([]); // Add this line
  const [showPopup, setShowPopup] = useState(false); // Add this line
  const filesPerPage = 20; // Number of files to display per page
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [fileToRemove, setFileToRemove] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const [pageNumber, setPageNumber] = useState("1");
  const [pageLimit, setPageLimit] = useState("20");
  const [totalRecord, setTotalRecord] = useState(0);
  const [timer, setTimer] = useState(null);

  useEffect(() => {
    const storedUserData = JSON.parse(localStorage.getItem("userData"));
    setUserData(storedUserData);

    fetchAllFiles(storedUserData);
  }, []);

  const handleCheckboxChange = (event, fileName) => {
    const checked = event.target.checked;
    if (checked) {
      setSelectedFiles((prevSelectedFiles) => [...prevSelectedFiles, fileName]);
    } else {
      setSelectedFiles((prevSelectedFiles) =>
        prevSelectedFiles.filter((file) => file !== fileName)
      );
    }
  };

  const delayExecution = (callback, ms) => {
    clearTimeout(timer);
    const newTimer = setTimeout(callback, ms);
    setTimer(newTimer);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    setPageNumber(pageNumber);
    formDataSubmit(pageNumber, searchKey);
  };

  const handleSearchChange = (event) => {
    setSearchKey(event.target.value);

    delayExecution(() => {
      formDataSubmit(pageNumber, event.target.value);
    }, 500);
  };

  const handleFilterButtonClick = () => {
    setShowPopup((prevShowPopup) => !prevShowPopup);
  };

  const formDataSubmit = (pageNumber, searchKey) => {
    const storedUserData = JSON.parse(localStorage.getItem("userData"));

    // Construct the URL with from_date and to_date parameters
    const form = new FormData();
    form.append("from_date", fromDate);
    form.append("to_date", toDate);
    form.append("search_key", searchKey);
    form.append("page_no", pageNumber);
    form.append("limit", pageLimit);

    fetch(`https://cliqestimatebuilder.com/waiver_admin/get-all-files`, {
      headers: {
        Authorization: `Bearer ${storedUserData.token}`,
      },
      method: "POST",
      body: form,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.data && Array.isArray(data.data)) {
          setFileData(data.data);

          // Check if totalRecord exists in the data object
          if ("totalRecord" in data) {
            setTotalRecord(data.totalRecord);
          } else {
            setTotalRecord(0); // Set totalRecord to 0 if it's not present in response
          }
        } else {
          setFileData([]);
          setTotalRecord(0);
          console.error("Received data is not in the expected format:", data);
        }
      })
      .catch((error) => console.error("Error fetching file data:", error));
  };

  const fetchAllFiles = (storedUserData) => {
    formDataSubmit(pageNumber, searchKey);
  };

  const handlePopupSubmit = (event) => {
    event.preventDefault();
    setShowPopup(false); // Close the popup
    setCurrentPage(1); // Reset to the first page

    formDataSubmit(pageNumber, searchKey);
  };

  const handleSearchSubmit = (event) => {
    event.preventDefault();
    setCurrentPage(1); // Reset to the first page
    formDataSubmit(pageNumber, searchKey);
  };

  const showPagination = Math.ceil(totalRecord / filesPerPage);

  const totalPages = Math.ceil(totalRecord / filesPerPage); // Calculate total pages

  const handleRemoveClick = (index, fileId) => {
    setFileToRemove({ index, fileId });
    setShowConfirmationModal(true);
  };

  const deleteFile = () => {
    if (fileToRemove) {
      const { index, fileId } = fileToRemove;

      const storedUserData = JSON.parse(localStorage.getItem("userData"));
      const formData = new FormData();
      formData.append("id", fileId);

      fetch(`https://cliqestimatebuilder.com/waiver_admin/files/${fileId}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${storedUserData.token}`,
        },
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          console.log(data);
          if (data.res == 1) {
            // Update the file list by removing the file at the specified index

            fetchAllFiles(storedUserData);
          } else {
            if (data.error) {
              console.error("Error deleting file:", data.error);
              // Handle the error condition if required
            } else {
              console.error("Error deleting file: Unknown error");
              // Handle other types of errors
            }
          }
        })
        .catch((error) =>
          console.error("Error changing delete status:", error)
        );

      setShowConfirmationModal(false);
      setFileToRemove(null);
    }
  };

  return (
    <div className="bodyMain">
      <div className="sideBar">
        <Sidebar />
      </div>

      <div className="contentDiv">
        <Header userData={userData} />

        <div className="mainContent">
          <div className="viewBox">
            <div className="topSearch">
              <div className="searchSec">
                <h2>All Files</h2>

                <div className="rgtSearch">
                  <form onSubmit={handleSearchSubmit}>
                    <input
                      type="search"
                      placeholder="Search here"
                      value={searchKey}
                      onChange={(e) => handleSearchChange(e)}
                    />
                    <button type="submit">
                      <img src={searchIcon} alt="" />
                    </button>
                  </form>
                  <button
                    className="filterBtn"
                    onClick={handleFilterButtonClick}
                  >
                    {showPopup ? "Close Filter" : "Open Filter"}
                  </button>

                  {showPopup && (
                    <div className="popup">
                      <form onSubmit={handlePopupSubmit}>
                        <label htmlFor="fromDate" className="fltrDate">
                          Filter by Created date
                        </label>
                        <div className="dateDiv">
                          <label htmlFor="toDate">From Date:</label>
                          <input
                            type="date"
                            id="fromDate"
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                          />
                        </div>
                        <div className="dateDiv">
                          <label htmlFor="toDate">To Date:</label>
                          <input
                            type="date"
                            id="toDate"
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                          />
                        </div>
                        <button type="submit">Submit</button>
                      </form>
                    </div>
                  )}
                  <div className="viewUploadFile">
                    <Link to="/upload-file">
                      <img src={uploadImg} alt="" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="viewFileList">
              <h3>Total {totalRecord} files</h3>
              <div className="listing viewTbl">
                <table>
                  <thead>
                    <tr>
                      <th></th>
                      <th>#</th>
                      <th>File Name</th>
                      {Number(userData?.role_id) === 1 ? (
                        <th>Created by</th>
                      ) : null}
                      <th>Upload Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  {fileData?.length > 0 ? (
                    <tbody>
                      {fileData.map((file, index) => (
                        <tr
                          key={index}
                          className={
                            selectedFiles.includes(file.file_name)
                              ? "active"
                              : ""
                          }
                        >
                          <td className="checkWidth">
                            <input
                              type="checkbox"
                              onChange={(event) =>
                                handleCheckboxChange(event, file.file_name)
                              }
                            />
                          </td>
                          <td className="countWidth">{index + 1}</td>
                          <td>{file.title}</td>
                          {Number(userData?.role_id) === 1 ? (
                            <td>{file.created_by}</td>
                          ) : null}
                          <td>{file.created_at}</td>
                          <td className="btnsWidth">
                            {selectedFiles.includes(file.file_name) ? (
                              <>
                                <Link
                                  to={{
                                    pathname: `/create-form/${file.id}`,
                                    state: { fileData: file },
                                  }}
                                  className="createBtn"
                                >
                                  Create Form
                                </Link>
                              </>
                            ) : null}
                            <button>
                              <Link
                                to={{
                                  pathname: `/view-one-file/${file.id}`,
                                  state: { fileData: file },
                                }}
                              >
                                <img src={viewIcon} alt="View" />
                              </Link>
                            </button>

                            <button
                              onClick={() => handleRemoveClick(index, file.id)}
                            >
                              <img src={removeIcon} alt="Remove" />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  ) : (
                    <tr>
                      <td colSpan={6} className="clsPan">
                        <span class="lgnStatus">Files Not Found</span>
                      </td>
                    </tr>
                  )}
                </table>
              </div>
              {showConfirmationModal ? (
                <div className="confirmation-modal">
                  <div className="modal-content">
                    <p>Are you sure you want to remove this file?</p>
                    <div className="modal-buttons">
                      <button onClick={deleteFile}>Yes</button>
                      <button onClick={() => setShowConfirmationModal(false)}>
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>

            {showPagination ? (
              <div className="paginationDiv">
                <ul>
                  {Array.from({ length: totalPages }, (_, index) => (
                    <li key={index}>
                      <Link
                        to="#"
                        className={currentPage === index + 1 ? "active" : ""}
                        onClick={() => handlePageChange(index + 1)}
                      >
                        {index + 1}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewFiles;
